import React from 'react';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import IconButton from '@material-ui/core/IconButton';
import TextField from '@material-ui/core/TextField';


import MultiSelectInput from '../../inputs/SelectInput';

import { BlueCloseIcon } from '../../../images/icons/WrapSvg';

class WastePopup extends React.Component {
    state = {
        open: false,
        products: null,
        units: 0,
        message: '',
        loading: false
    };

    handleChangeProces = (event) => {
        this.setState({ products: event });
    };


    handleChangeMessage = (event) => {
        this.setState({ message: event });
    };


    handleMinus = (event) => {
        if (this.state.units > 0) this.setState({ units: this.state.units - 1 });
    };

    handlePlus = (event) => {
        this.setState({ units: this.state.units + 1 });
    };

    handleChangeClick = (add) => (event) => {
        const { units } = this.state;
        const value = parseInt(units.toString().concat(add), 10);
        this.setState({ units: value });
    };

    handleRemoveUnits = (event) => {
        this.setState({ units: 0 });
    }

    handleChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    };

    handleSummit = (event) => {

        const product = {
            idLocal: this.props.id,
            idProducto: this.state.products.value,
            cantidad: this.state.units,
            motivo: this.state.message.value,
        };
        this.setState({ loading: true })
        this.props
            .wasteProduct(product)
            .then(() => { this.props.handleClose('waste', false); })
            .catch((error) => this.props.handleClose('waste', error.message));

    };

    render() {
        const { products, units, message, loading } = this.state;
        const { handleClose, intl } = this.props;
        return (
            <Dialog
                onClose={() => handleClose('waste', false)}
                aria-labelledby="customized-dialog-title"
                open={true}
                classes={{
                    paper: 'xhef_waste_popup',
                }}
            >
                <div className="flex_full_column">
                    <div className="flex_auto_row xhef_waste_popup_header align_center">
                        <IconButton
                            aria-label="Close"
                            className={''}
                            onClick={() => handleClose('waste', false)}
                        >
                            <BlueCloseIcon />
                        </IconButton>
                        <div className="flex_full_row center barlowsemicondensed_bold">
                            <FormattedMessage id="xhef_popup_waste_title" />
                        </div>
                    </div>
                    <div className="flex_auto_row">
                        <div className="flex_full_column padding_borders">
                            <div className="flex_auto_row align_center">
                                <MultiSelectInput
                                    defaultValue={products}
                                    placeHolder={intl.formatMessage({
                                        id: 'xhef_popup_waste_products_title',
                                    })}
                                    isNotSearchable
                                    options={
                                        this.props.products
                                            ? this.props.products.reduce((arr, f) => {
                                                if (f.incluirDesperdicio)
                                                    arr.push({
                                                        label: f.nombre.toUpperCase(),
                                                        value: f.id,
                                                    });
                                                return arr;
                                            }, [])
                                            : []
                                    }
                                    onChange={this.handleChangeProces}
                                />
                            </div>
                            <div className="flex_auto_row align_center margin_top_32">
                                <MultiSelectInput
                                    defaultValue={message}
                                    placeHolder={intl.formatMessage({
                                        id: 'xhef_popup_message_title',
                                    })}
                                    isNotSearchable
                                    options={[
                                        {
                                            label: intl.formatMessage({ id: 'xhef_popup_waste_message_expiraded' }),
                                            value: 0,
                                        },
                                        {
                                            label: intl.formatMessage({ id: 'xhef_popup_waste_message_missing' }),
                                            value: 1,
                                        },
                                        {
                                            label: intl.formatMessage({ id: 'xhef_popup_waste_message_temperature_control' }),
                                            value: 2,
                                        },
                                        {
                                            label: intl.formatMessage({ id: 'xhef_popup_waste_message_fail' }),
                                            value: 3,
                                        },
                                        {
                                            label: intl.formatMessage({ id: 'xhef_popup_waste_message_customer' }),
                                            value: 4,
                                        },
                                        {
                                            label: intl.formatMessage({ id: 'xhef_popup_waste_message_fall_down' }),
                                            value: 5,
                                        },
                                        {
                                            label: intl.formatMessage({ id: 'xhef_popup_waste_message_other' }),
                                            value: 6,
                                        }
                                    ]}
                                    onChange={this.handleChangeMessage}
                                />
                            </div>
                            <div className="flex_auto_row margin_top_32 align_center">
                                <TextField
                                    required
                                    fullWidth
                                    name={'units'}
                                    id={'units'}
                                    label={intl.formatMessage({
                                        id: 'xhef_popup_waste_units_title',
                                    })}
                                    disabled={true}
                                    value={units}
                                    type="number"
                                    inputProps={{
                                        className: 'barlowcondensed_regular c_black',
                                        pattern: '[0-9]*',
                                        style: { textAlign: 'center' },
                                    }}
                                    onChange={this.handleChange}
                                    className="text_align_center"
                                />
                            </div>
                            <div className="flex_auto_row ">
                                <div className="flex_full_column">
                                    <div className="flex_full_row center margin_top_32 ">
                                        <Button
                                            onClick={this.handleChangeClick(0)}
                                            color="primary"
                                            variant="outlined"
                                            className="xef_calculator_button barlowsemicondensed_regular no_uppercase c_bluish margin_right_6"
                                        >
                                            0
                                        </Button>
                                        <Button
                                            onClick={this.handleChangeClick(1)}
                                            color="primary"
                                            variant="outlined"
                                            className="xef_calculator_button barlowsemicondensed_regular no_uppercase c_bluish margin_right_6"
                                        >
                                            1
                                        </Button>
                                        <Button
                                            onClick={this.handleChangeClick(2)}
                                            color="primary"
                                            variant="outlined"
                                            className="xef_calculator_button barlowsemicondensed_regular no_uppercase c_bluish margin_right_6"
                                        >
                                            2
                                        </Button>
                                        <Button
                                            onClick={this.handleChangeClick(3)}
                                            color="primary"
                                            variant="outlined"
                                            className="xef_calculator_button barlowsemicondensed_regular no_uppercase c_bluish margin_right_6"
                                        >
                                            3
                                        </Button>
                                        <Button
                                            onClick={this.handleChangeClick(4)}
                                            color="primary"
                                            variant="outlined"
                                            className="xef_calculator_button barlowsemicondensed_regular no_uppercase c_bluish margin_right_6"
                                        >
                                            4
                                        </Button>
                                    </div>
                                    <div className="flex_full_row center margin_top_32 ">
                                        <Button
                                            onClick={this.handleChangeClick(5)}
                                            color="primary"
                                            variant="outlined"
                                            className="xef_calculator_button barlowsemicondensed_regular no_uppercase c_bluish margin_right_6"
                                        >
                                            5
                                        </Button>
                                        <Button
                                            onClick={this.handleChangeClick(6)}
                                            color="primary"
                                            variant="outlined"
                                            className="xef_calculator_button barlowsemicondensed_regular no_uppercase c_bluish margin_right_6"
                                        >
                                            6
                                        </Button>
                                        <Button
                                            onClick={this.handleChangeClick(7)}
                                            color="primary"
                                            variant="outlined"
                                            className="xef_calculator_button barlowsemicondensed_regular no_uppercase c_bluish margin_right_6"
                                        >
                                            7
                                        </Button>
                                        <Button
                                            onClick={this.handleChangeClick(8)}
                                            color="primary"
                                            variant="outlined"
                                            className="xef_calculator_button barlowsemicondensed_regular no_uppercase c_bluish margin_right_6"
                                        >
                                            8
                                        </Button>
                                        <Button
                                            onClick={this.handleChangeClick(9)}
                                            color="primary"
                                            variant="outlined"
                                            className="xef_calculator_button barlowsemicondensed_regular no_uppercase c_bluish margin_right_6"
                                        >
                                            9
                                        </Button>
                                    </div>
                                </div>
                                <Button
                                    onClick={this.handleRemoveUnits}
                                    color="primary"
                                    variant="outlined"
                                    className="xef_calculator_button barlowsemicondensed_regular no_uppercase c_bluish margin_right_6 margin_top_32"
                                >
                                    {
                                        intl.formatMessage({
                                            id: 'remove',
                                        })
                                    }
                                </Button>
                            </div>
                        </div>
                    </div>
                    <div className="flex_auto_row center xhef_waste_popup_footer">
                        <Button
                            disabled={units <= 0 || !products || products.length === 0 || loading}
                            variant="contained"
                            color="primary"
                            className={'flex_full_row barlow_semibold padding_borders'}
                            onClick={this.handleSummit}
                        >
                            <FormattedMessage id="xhef_popup_waste_button_title" />
                        </Button>
                    </div>
                </div>
            </Dialog>
        );
    }
}

WastePopup.propTypes = {
    intl: intlShape.isRequired,
};

export default injectIntl(WastePopup);



// WEBPACK FOOTER //
// ./src/components/complex/xhef/WastePopup.js